<span aria-live="polite">
    <fa-icon icon="spinner" [animation]="'spin'" class="teal"></fa-icon>
    <ng-container *transloco="let t">
    {{ t('Loading.Prefix') }} {{description}}
</ng-container>
</span>